import { IFacilityNote } from 'src/app/models/facility';
import {
    FacilityRequest,
    IFacilityRequestConfig,
    IFacilityRequestForSmartAction,
    IFacilityRequestListItem,
} from 'src/app/models/facility-request';

import { SmartActionContext } from '../../models/smart-actions.models';




export class FacilityRequestStateModel {
    currentFacilityRequestListItem: IFacilityRequestListItem;
    smartActions: SmartActionContext;
    currentFacilityRequestTab?: string;
    currentFacilityRequestConfig?: IFacilityRequestConfig;
    currentFacilityRequestForSmartAction?: IFacilityRequestForSmartAction;
    currentFacilityRequestNotes: IFacilityNote[];
    currentFacilityRequest: FacilityRequest;
}


export interface ICustomView {
    id: string;
    metadata: any;
}
